/* VELICIA 2.0: Skript des Rahmens. layout/theme.liquid lädt es mit defer auf jeder Seite. Kein fremder Code.
   1. Schubladen und Flächen: [data-velicia-oeffne="warenkorb|menue|suche"] öffnet [data-velicia-schublade="..."];
      [data-velicia-schliesse], ein Klick auf den Schleier und Escape schließen. Der Fokus geht hinein, bleibt drin
      (Fokusfalle) und kehrt zum Auslöser zurück. Solange etwas offen ist, trägt body die Klasse velicia--gesperrt.
   2. Kopf: "ist-gescrollt" ab etwa 40 px Scrollweg (auf der Startseite wird der durchsichtige Kopf damit Elfenbein),
      "ist-eng", wenn das Menü am PC nicht neben die Wortmarke passt (dann bleibt der Menü-Knopf).
   3. Warenkorb: der Inhalt von [data-velicia-warenkorb-abschnitt="<Kennung>"] kommt frisch über die Section
      Rendering API (/?sections=<Kennung>), [data-velicia-warenkorb-zahl] zeigt die Stückzahl. Nach jeder Änderung:
      Ereignis "velicia:warenkorb" am document, detail = der Warenkorb, wie Shopify ihn liefert.
   4. Menge und Entfernen: <form data-velicia-menge> geht an /cart/change.js (line + quantity, Entfernen = 0).
   5. Kaufen: <form data-velicia-kauf> geht als FormData an /cart/add.js, danach öffnet sich die Warenkorb-Schublade.
   6. Einblenden: .velicia-ein bekommt "ist-da", sobald es ins Bild kommt.
   Jedes Element darf fehlen. Ohne dieses Skript bleiben alle Links und Formulare benutzbar: sie führen auf /cart,
   /search, /cart/add und /cart/change. */
(function () {
  'use strict';
  if (window.veliciaRahmen) return;
  window.veliciaRahmen = true;

  var doc = document;
  /* Wurzel des Shops; mit Sprach-Verzeichnis zum Beispiel "/en/". */
  var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* Kennung des festen Abschnitts im Layout ({% section 'velicia-warenkorb-schublade' %}). */
  var SCHUBLADE = 'velicia-warenkorb-schublade';
  var NICHT_GEKLAPPT = 'Das hat gerade nicht geklappt. Bitte versuch es noch einmal.';
  var kannLaden = !!(window.fetch && window.Promise && window.FormData && window.DOMParser);

  function alle(wurzelElement, auswahl) {
    return Array.prototype.slice.call(wurzelElement.querySelectorAll(auswahl));
  }
  function imBild(tun) {
    if (window.requestAnimationFrame) window.requestAnimationFrame(tun);
    else window.setTimeout(tun, 16);
  }
  function imDokument(element) {
    return !!element && doc.documentElement.contains(element);
  }
  function sichtbar(element) {
    return !!element && element.getClientRects().length > 0;
  }
  function fokus(element) {
    if (!element || !element.focus) return;
    try { element.focus({ preventScroll: true }); } catch (fehler) { element.focus(); }
  }

  /* --- 1. Schubladen und Flächen ------------------------------------------------------- */
  var offen = null; /* { name, flaeche, ausloeser } oder null: es ist immer höchstens eine offen */
  var FOKUSSIERBAR = 'a[href], button, input, select, textarea, summary, [tabindex]';

  function flaecheVon(name) {
    if (!name || !/^[a-z0-9-]+$/i.test(name)) return null;
    return doc.querySelector('[data-velicia-schublade="' + name + '"]');
  }

  /* Der Schleier steht im Layout. Fehlt er einmal, legt das Skript ihn an. */
  function schleier(anlegen) {
    var element = doc.querySelector('[data-velicia-schleier]') || doc.querySelector('.velicia-schleier');
    if (!element && anlegen && doc.body) {
      element = doc.createElement('div');
      element.className = 'velicia-schleier';
      element.setAttribute('data-velicia-schleier', '');
      doc.body.appendChild(element);
    }
    return element;
  }

  /* Seite festhalten. Verschwindet dabei eine Bildlaufleiste, gleicht ein Rand ihre Breite aus: nichts springt. */
  function sperren(an) {
    var koerper = doc.body;
    if (!koerper) return;
    if (an) {
      var luecke = window.innerWidth - doc.documentElement.clientWidth;
      koerper.classList.add('velicia--gesperrt');
      if (luecke > 0) koerper.style.paddingRight = luecke + 'px';
    } else {
      koerper.classList.remove('velicia--gesperrt');
      koerper.style.paddingRight = '';
    }
  }

  function ausloeserMelden(name, zustand) {
    alle(doc, '[data-velicia-oeffne="' + name + '"][aria-expanded]').forEach(function (knopf) {
      knopf.setAttribute('aria-expanded', zustand ? 'true' : 'false');
    });
  }

  function fokussierbare(flaeche) {
    return alle(flaeche, FOKUSSIERBAR).filter(function (element) {
      return !element.disabled && element.tabIndex >= 0 && element.type !== 'hidden' && sichtbar(element);
    });
  }

  function oeffne(name, ausloeser) {
    var flaeche = flaecheVon(name);
    if (!flaeche) return false;
    if (offen && offen.flaeche === flaeche) return true;
    if (offen) schliesse(false);
    offen = { name: name, flaeche: flaeche, ausloeser: ausloeser || null };

    flaeche.classList.add('ist-offen');
    flaeche.setAttribute('aria-hidden', 'false');
    var decke = schleier(true);
    if (decke) decke.classList.add('ist-offen');
    /* Die Suche sitzt im Kopf: er hebt sich mit ihr über den Schleier. */
    var kopf = flaeche.closest('[data-velicia-kopf]');
    if (kopf) kopf.classList.add('ist-offen');
    sperren(true);
    ausloeserMelden(name, true);

    var ziel = flaeche.querySelector('[data-velicia-fokus]') || flaeche;
    fokus(ziel);
    if (ziel !== flaeche && ziel.select && ziel.value) ziel.select();
    return true;
  }

  /* fokusZurueck === false: nur schließen (eine andere Fläche geht gleich auf, oder der Auslöser ist fort). */
  function schliesse(fokusZurueck) {
    if (!offen) return;
    var war = offen;
    offen = null;

    war.flaeche.classList.remove('ist-offen');
    war.flaeche.setAttribute('aria-hidden', 'true');
    var decke = schleier(false);
    if (decke) decke.classList.remove('ist-offen');
    var kopf = war.flaeche.closest('[data-velicia-kopf]');
    if (kopf) kopf.classList.remove('ist-offen');
    sperren(false);
    ausloeserMelden(war.name, false);

    if (fokusZurueck === false) return;
    if (imDokument(war.ausloeser) && sichtbar(war.ausloeser) && !war.ausloeser.disabled) fokus(war.ausloeser);
    else if (war.flaeche.contains(doc.activeElement) && doc.activeElement.blur) doc.activeElement.blur();
  }

  /* Der Theme-Editor kann einen Abschnitt samt offener Fläche austauschen: dann den Zustand zurücksetzen. */
  function aufraeumen() {
    if (!offen || imDokument(offen.flaeche)) return;
    offen = null;
    var decke = schleier(false);
    if (decke) decke.classList.remove('ist-offen');
    sperren(false);
  }

  doc.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    if (!ziel || !ziel.closest) return;

    /* Für Browser ohne event.submitter: merken, welcher Knopf ein Formular absendet. */
    var absender = ziel.closest('button, input[type="submit"]');
    if (absender && absender.form && absender.type === 'submit') absender.form.veliciaKnopf = absender;

    var oeffner = ziel.closest('[data-velicia-oeffne]');
    if (oeffner) {
      /* Neuer Tab, neues Fenster: der Link soll einfach ein Link bleiben. */
      if (ereignis.defaultPrevented || ereignis.button > 0 || ereignis.metaKey || ereignis.ctrlKey || ereignis.shiftKey || ereignis.altKey) return;
      var name = oeffner.getAttribute('data-velicia-oeffne');
      if (offen && offen.name === name) {
        ereignis.preventDefault();
        schliesse();
      } else if (oeffne(name, oeffner)) {
        ereignis.preventDefault();
      }
      /* Gibt es die Fläche auf dieser Seite nicht (Warenkorb-Seite), führt der Link ganz normal an sein Ziel. */
      return;
    }

    if (!offen) return;
    if (ziel.closest('[data-velicia-schliesse]')) {
      ereignis.preventDefault();
      schliesse();
    } else if (ziel.closest('[data-velicia-schleier], .velicia-schleier')) {
      schliesse();
    }
  });

  doc.addEventListener('keydown', function (ereignis) {
    if (!offen) return;
    var taste = ereignis.key;
    if (taste === 'Escape' || taste === 'Esc') {
      ereignis.preventDefault();
      schliesse();
      return;
    }
    if (taste !== 'Tab') return;

    /* Fokusfalle: Tab läuft in der offenen Fläche im Kreis. */
    var flaeche = offen.flaeche;
    var liste = fokussierbare(flaeche);
    if (!liste.length) {
      ereignis.preventDefault();
      fokus(flaeche);
      return;
    }
    var erstes = liste[0];
    var letztes = liste[liste.length - 1];
    var aktiv = doc.activeElement;
    var drin = flaeche.contains(aktiv);
    if (ereignis.shiftKey) {
      if (!drin || aktiv === erstes || aktiv === flaeche) {
        ereignis.preventDefault();
        fokus(letztes);
      }
    } else if (!drin || aktiv === letztes) {
      ereignis.preventDefault();
      fokus(erstes);
    }
  });

  /* --- 2. Kopf ------------------------------------------------------------------------ */
  var kopfElement = null;
  var rollt = false;
  var zieht = false;
  var breitGenug = window.matchMedia ? window.matchMedia('(min-width: 1200px)') : null;

  function kopfFinden() {
    if (!imDokument(kopfElement)) kopfElement = doc.querySelector('[data-velicia-kopf]');
    return kopfElement;
  }

  /* Oben oder gescrollt: geschrieben wird nur, wenn sich der Zustand ändert. */
  function kopfZustand() {
    rollt = false;
    var kopf = kopfFinden();
    if (!kopf) return;
    var unten = (window.pageYOffset || doc.documentElement.scrollTop || 0) > 40;
    if (kopf.classList.contains('ist-gescrollt') !== unten) kopf.classList.toggle('ist-gescrollt', unten);
  }

  /* Passt das Menü am PC neben die Wortmarke? Wenn nicht, bleibt der Menü-Knopf (Klasse "ist-eng"). */
  function kopfMessen() {
    var kopf = kopfFinden();
    if (!kopf) return;
    var leisten = alle(kopf, '[data-velicia-kopf-nav]');
    if (!leisten.length) return;
    kopf.classList.remove('ist-eng');
    if (!breitGenug || !breitGenug.matches) return;
    var eng = leisten.some(function (leiste) { return leiste.scrollWidth > leiste.clientWidth + 1; });
    if (eng) kopf.classList.add('ist-eng');
  }

  window.addEventListener('scroll', function () {
    if (rollt) return;
    rollt = true;
    imBild(kopfZustand);
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (zieht) return;
    zieht = true;
    imBild(function () {
      zieht = false;
      kopfMessen();
      /* Fenster breiter gezogen, der Menü-Knopf ist fort: dann hat die Menü-Schublade nichts mehr offen zu stehen. */
      if (offen && offen.name === 'menue' && offen.ausloeser && !sichtbar(offen.ausloeser)) schliesse(false);
    });
  });

  /* --- 3. Warenkorb: Stand holen und zeigen ------------------------------------------------ */
  function meldungAus(daten) {
    if (!daten || typeof daten !== 'object') return '';
    var roh = daten.description || daten.message || daten.errors || '';
    if (roh && typeof roh === 'object') {
      var teile = [];
      Object.keys(roh).forEach(function (schluessel) { teile = teile.concat(roh[schluessel]); });
      roh = teile.join(' ');
    }
    return typeof roh === 'string' ? roh : '';
  }

  /* Antwort von Shopify lesen. Bei einem Fehler trägt der Grund die Meldung aus der Antwort (velicia = true). */
  function lies(antwort) {
    return antwort.text().then(function (text) {
      var daten = null;
      try { daten = JSON.parse(text); } catch (fehler) { daten = null; }
      if (!antwort.ok || !daten || typeof daten !== 'object') {
        var grund = new Error(meldungAus(daten) || NICHT_GEKLAPPT);
        grund.velicia = true;
        throw grund;
      }
      return daten;
    });
  }
  function hole(adresse) {
    return window.fetch(adresse, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(lies);
  }
  function sende(adresse, inhalt) {
    var kopfzeilen = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (typeof inhalt === 'string') kopfzeilen['Content-Type'] = 'application/json';
    return window.fetch(adresse, { method: 'POST', credentials: 'same-origin', headers: kopfzeilen, body: inhalt }).then(lies);
  }
  /* Nur Meldungen von Shopify werden gezeigt; alles andere (kein Netz, Abbruch) bekommt den ruhigen Standardsatz. */
  function meldungVon(grund) {
    return grund && grund.velicia && grund.message ? grund.message : NICHT_GEKLAPPT;
  }

  function kennungVon(platz) {
    return platz.getAttribute('data-velicia-warenkorb-abschnitt') || (platz.closest('[data-velicia-schublade="warenkorb"]') ? SCHUBLADE : '');
  }

  /* Alle Warenkorb-Abschnitte der Seite in einer Anfrage. Die Schublade ist ein fester Abschnitt und kommt von der
     Wurzel (/?sections=velicia-warenkorb-schublade). Ein Abschnitt aus einer Vorlage (Kennung "template--...", die
     Warenkorb-Seite) lässt sich nur auf seiner eigenen Seite holen, dann geht die Anfrage an die aktuelle Adresse. */
  function abschnitteHolen() {
    var kennungen = [];
    var ausVorlage = false;
    alle(doc, '[data-velicia-warenkorb-abschnitt]').forEach(function (platz) {
      var kennung = kennungVon(platz);
      if (!kennung || kennungen.indexOf(kennung) > -1) return;
      kennungen.push(kennung);
      if (kennung.indexOf('template--') === 0) ausVorlage = true;
    });
    if (!kennungen.length) return window.Promise.resolve(null);
    var basis = ausVorlage ? window.location.pathname : wurzel;
    return hole(basis + '?sections=' + kennungen.map(encodeURIComponent).join(','));
  }

  /* Nach dem Austausch steht der Fokus wieder auf demselben Knopf (data-velicia-merk), sonst auf der Fläche. */
  function fokusNach(platz, merk) {
    var ziel = null;
    if (merk) {
      alle(platz, '[data-velicia-merk]').some(function (element) {
        if (element.getAttribute('data-velicia-merk') !== merk) return false;
        ziel = element;
        return true;
      });
    }
    if (!ziel) ziel = platz.closest('[data-velicia-schublade]') || (platz.hasAttribute('tabindex') ? platz : null);
    fokus(ziel);
  }

  function abschnitteEinsetzen(teile) {
    if (!teile) return;
    alle(doc, '[data-velicia-warenkorb-abschnitt]').forEach(function (platz) {
      var html = teile[kennungVon(platz)];
      if (!html || typeof html !== 'string') return;
      var neu = new window.DOMParser().parseFromString(html, 'text/html').querySelector('[data-velicia-warenkorb-abschnitt]');
      if (!neu) return;

      var aktiv = doc.activeElement;
      var hatteFokus = !!aktiv && aktiv !== platz && platz.contains(aktiv);
      var merk = hatteFokus ? aktiv.getAttribute('data-velicia-merk') : '';
      var rolle = platz.querySelector('.velicia-schublade__inhalt');
      var stand = rolle ? rolle.scrollTop : 0;

      platz.innerHTML = neu.innerHTML;

      rolle = platz.querySelector('.velicia-schublade__inhalt');
      if (rolle && stand) rolle.scrollTop = stand;
      if (hatteFokus) fokusNach(platz, merk);
    });
  }

  function zahlZeigen(zahl) {
    if (typeof zahl !== 'number' || isNaN(zahl)) return;
    alle(doc, '[data-velicia-warenkorb-zahl]').forEach(function (element) {
      element.textContent = String(zahl);
      element.setAttribute('data-velicia-warenkorb-zahl', String(zahl));
      element.hidden = zahl < 1;
    });
  }

  /* Beim Laden steht die Zahl schon im HTML: hier wird sie nur bei 0 versteckt. */
  function zahlPruefen() {
    alle(doc, '[data-velicia-warenkorb-zahl]').forEach(function (element) {
      var zahl = parseInt(element.getAttribute('data-velicia-warenkorb-zahl') || element.textContent, 10);
      element.hidden = !(zahl > 0);
    });
  }

  function melden(warenkorb) {
    var ereignis;
    try {
      ereignis = new window.CustomEvent('velicia:warenkorb', { detail: warenkorb });
    } catch (fehler) {
      ereignis = doc.createEvent('CustomEvent');
      ereignis.initCustomEvent('velicia:warenkorb', false, false, warenkorb);
    }
    doc.dispatchEvent(ereignis);
  }

  /* Warenkorb neu laden: Abschnitte austauschen, Zahl setzen, Bescheid geben. bekannt = der Warenkorb, falls
     Shopify ihn gerade schon geliefert hat (/cart/change.js), sonst holt ihn /cart.js. */
  function erneuern(bekannt) {
    if (!kannLaden) return null;
    var warenkorb = bekannt && typeof bekannt.item_count === 'number' ? window.Promise.resolve(bekannt) : hole(wurzel + 'cart.js');
    return window.Promise.all([warenkorb, abschnitteHolen()]).then(function (beide) {
      abschnitteEinsetzen(beide[1]);
      zahlZeigen(beide[0].item_count);
      melden(beide[0]);
      return beide[0];
    });
  }

  /* --- 4. Menge ändern und Entfernen ----------------------------------------------------- */
  var aendert = false; /* Es läuft immer nur eine Änderung: die Zeilen-Nummern gelten nur für den gezeigten Stand. */

  function zeilenNummer(zeile) {
    if (!zeile) return 0;
    var nummer = parseInt(zeile.getAttribute('data-velicia-zeile'), 10);
    if (nummer > 0) return nummer;
    var platz = zeile.closest('[data-velicia-warenkorb-abschnitt]') || doc;
    return alle(platz, '[data-velicia-zeile]').indexOf(zeile) + 1;
  }

  function fehlerZeigen(platz, meldung) {
    var feld = platz ? platz.querySelector('[data-velicia-warenkorb-fehler]') : null;
    if (!feld) return;
    feld.textContent = meldung;
    feld.hidden = !meldung;
  }

  function mengeAendern(ereignis, formular) {
    if (!kannLaden || ereignis.defaultPrevented) return;
    var knopf = ereignis.submitter || formular.veliciaKnopf || null;
    var menge = knopf && knopf.name === 'quantity' ? parseInt(knopf.value, 10) : NaN;
    var zeile = formular.closest('[data-velicia-zeile]');
    var nummer = zeilenNummer(zeile);
    if (isNaN(menge) || menge < 0 || !nummer) return; /* unklar: das Formular geht den normalen Weg über /cart/change */

    ereignis.preventDefault();
    if (aendert) return;
    aendert = true;
    var platz = formular.closest('[data-velicia-warenkorb-abschnitt]');
    zeile.setAttribute('aria-busy', 'true');
    if (platz) platz.setAttribute('aria-busy', 'true');
    fehlerZeigen(platz, '');

    function fertig(meldung) {
      aendert = false;
      zeile.removeAttribute('aria-busy');
      if (platz) platz.removeAttribute('aria-busy');
      if (meldung) fehlerZeigen(platz, meldung);
    }

    sende(wurzel + 'cart/change.js', JSON.stringify({ line: nummer, quantity: menge }))
      .then(function (warenkorb) { return erneuern(warenkorb); })
      .then(function () {
        fertig('');
      }, function (grund) {
        /* Erst den wahren Stand zeigen (Shopify lässt zum Beispiel nicht mehr zu, als auf Lager ist), dann die Meldung. */
        var meldung = meldungVon(grund);
        return erneuern().then(function () { fertig(meldung); }, function () { fertig(meldung); });
      })
      .then(null, function () { aendert = false; });
  }

  /* --- 5. Kaufen ------------------------------------------------------------------------- */
  function zeigeMeldung(feld) {
    var lage = feld.getBoundingClientRect();
    var oben = (kopfFinden() ? kopfFinden().offsetHeight : 0) + 8;
    if (lage.top >= oben && lage.bottom <= window.innerHeight) return;
    try { feld.scrollIntoView({ block: 'center' }); } catch (fehler) { feld.scrollIntoView(); }
  }

  function kaufen(ereignis, formular) {
    /* Ohne fetch geht das Formular den normalen Weg. Hat ein anderes Skript das Absenden schon angehalten
       (fehlende Personalisierung, assets/velicia-produkt.js), bleibt es dabei. */
    if (!kannLaden || ereignis.defaultPrevented) return;
    ereignis.preventDefault();
    if (formular.veliciaLaeuft) return;
    formular.veliciaLaeuft = true;

    var daten = new window.FormData(formular);
    var knoepfe = Array.prototype.filter.call(formular.elements, function (feld) { return feld.type === 'submit'; });
    var ausloeser = ereignis.submitter || formular.veliciaKnopf || knoepfe[0] || null;
    var meldung = formular.querySelector('[data-velicia-kauf-fehler]');
    var gesperrt = [];
    if (meldung) meldung.textContent = '';
    knoepfe.forEach(function (knopf) {
      knopf.setAttribute('aria-busy', 'true');
      if (!knopf.disabled) {
        knopf.disabled = true;
        gesperrt.push(knopf);
      }
    });

    function frei() {
      formular.veliciaLaeuft = false;
      knoepfe.forEach(function (knopf) { knopf.removeAttribute('aria-busy'); });
      gesperrt.forEach(function (knopf) { knopf.disabled = false; });
    }

    sende(wurzel + 'cart/add.js', daten)
      .then(function () {
        return erneuern().then(function () {
          frei();
          /* Keine Schublade und kein Warenkorb auf dieser Seite: dann zeigt die Warenkorb-Seite, was passiert ist. */
          if (!oeffne('warenkorb', ausloeser) && !doc.querySelector('[data-velicia-warenkorb-abschnitt]')) window.location.assign(wurzel + 'cart');
        }, function () {
          /* Das Stück liegt im Warenkorb, nur die Anzeige ließ sich nicht holen. */
          frei();
          window.location.assign(wurzel + 'cart');
        });
      }, function (grund) {
        frei();
        if (meldung) {
          meldung.textContent = meldungVon(grund);
          zeigeMeldung(meldung);
        }
        /* Der gesperrte Knopf hat den Fokus verloren: zurückgeben. */
        if ((!doc.activeElement || doc.activeElement === doc.body) && sichtbar(ausloeser)) fokus(ausloeser);
      })
      .then(null, frei);
  }

  doc.addEventListener('submit', function (ereignis) {
    var formular = ereignis.target;
    if (!formular || !formular.hasAttribute) return;
    if (formular.hasAttribute('data-velicia-kauf')) kaufen(ereignis, formular);
    else if (formular.hasAttribute('data-velicia-menge')) mengeAendern(ereignis, formular);
  });

  /* Zurück-Taste des Browsers: die Seite kommt aus dem Zwischenspeicher und kennt den Warenkorb von vorhin. */
  window.addEventListener('pageshow', function (ereignis) {
    if (!ereignis.persisted) return;
    var lauf = erneuern();
    if (lauf) lauf.then(null, function () {});
  });

  /* --- 6. Einblenden ----------------------------------------------------------------------- */
  var waechter = null;

  function einblenden(wurzelElement) {
    var teile = alle(wurzelElement, '.velicia-ein:not(.ist-da)');
    if (wurzelElement.classList && wurzelElement.classList.contains('velicia-ein') && !wurzelElement.classList.contains('ist-da')) teile.push(wurzelElement);
    if (!teile.length) return;
    if (!('IntersectionObserver' in window)) {
      teile.forEach(function (teil) { teil.classList.add('ist-da'); });
      return;
    }
    if (!waechter) {
      waechter = new window.IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (eintrag) {
          if (!eintrag.isIntersecting) return;
          eintrag.target.classList.add('ist-da');
          waechter.unobserve(eintrag.target);
        });
      }, { rootMargin: '0px 0px -32px 0px' });
    }
    teile.forEach(function (teil) { waechter.observe(teil); });
  }

  /* --- Start, auch wenn der Theme-Editor einen Abschnitt neu lädt ------------------------------ */
  function start(wurzelElement) {
    aufraeumen();
    zahlPruefen();
    kopfZustand();
    kopfMessen();
    einblenden(wurzelElement);
  }

  doc.addEventListener('shopify:section:load', function (ereignis) { start(ereignis.target); });
  /* Im Editor: wer den Abschnitt der Warenkorb-Schublade anwählt, sieht sie auch. */
  doc.addEventListener('shopify:section:select', function (ereignis) {
    var ziel = ereignis.target;
    if (ziel && ziel.querySelector && ziel.querySelector('[data-velicia-schublade="warenkorb"]')) oeffne('warenkorb', null);
  });
  doc.addEventListener('shopify:section:deselect', function (ereignis) {
    if (offen && offen.name === 'warenkorb' && ereignis.target && ereignis.target.contains(offen.flaeche)) schliesse(false);
  });

  /* Mit der geladenen Schrift ändern sich die Breiten im Kopf: noch einmal messen. */
  if (doc.fonts && doc.fonts.ready && doc.fonts.ready.then) doc.fonts.ready.then(kopfMessen);
  window.addEventListener('load', kopfMessen);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { start(doc); });
  else start(doc);
})();
